import groupBy from "lodash/groupBy";
import orderBy from "lodash/orderBy";
import uniqBy from "lodash/uniqBy";
import dayjs from "dayjs";
import type { ComponentMessageType } from "../ChatComponent/types/ComponentMessageType";

export const groupMessagesByLastMessage = (messages: ComponentMessageType[]) => {
  return orderBy(
    Object.values(groupBy(messages, "id")).map((groupedMessages) => {
      let editedMessages: ComponentMessageType[] = [];
      const orderedMessages = orderBy(groupedMessages, ["latestUpdate"], ["desc"]);
      const firstItem = orderedMessages[0];
      const datetime = typeof firstItem.datetime === "string" ? dayjs(firstItem.datetime).valueOf() : firstItem.datetime;

      const isDeleted = orderedMessages.some((message) => message.isDeleted);
      const isEdited =
        firstItem.isEdited ?? (groupedMessages.length > 1 || Boolean(firstItem.latestUpdate && Number(firstItem.latestUpdate) > datetime));

      if (isEdited || isDeleted) {
        editedMessages = uniqBy(orderBy(groupedMessages, ["latestUpdate"], ["asc"]), (item) => `${item.latestUpdate}-${item.msgId}`);
        if (editedMessages.length > 0) {
          const deletedMessages = uniqBy(
            editedMessages.filter((message) => message.isDeleted),
            "isDeleted"
          );
          if (deletedMessages.length > 0) {
            editedMessages = [...editedMessages.filter((message) => !message.isDeleted), ...deletedMessages];
          }
        }
      }

      return {
        ...firstItem,
        editedMessages,
        isEdited,
        isDeleted,
        datetime,
      };
    }),
    ["datetime"],
    ["asc"]
  );
};
